export interface RaceClock {
  /** Epoch time for persisted records, leases, and server deadlines. */
  wallNow(): number;
  /** Monotonic elapsed time for simulation cadence, throttles, and retries. */
  monotonicNow(): number;
}

export const SYSTEM_RACE_CLOCK: RaceClock = Object.freeze({
  wallNow: () => Date.now(),
  monotonicNow: () => {
    const runtime = globalThis as typeof globalThis & {
      performance?: { now(): number };
    };
    return typeof runtime.performance?.now === 'function'
      ? runtime.performance.now()
      : Date.now();
  },
});

/** Deterministic clock used by replay tools and tests. */
export class ManualRaceClock implements RaceClock {
  constructor(
    private wallTime = 0,
    private monotonicTime = 0,
  ) {}

  wallNow(): number {
    return this.wallTime;
  }

  monotonicNow(): number {
    return this.monotonicTime;
  }

  set(wallTime: number, monotonicTime = wallTime): void {
    this.wallTime = finiteTime(wallTime);
    this.monotonicTime = finiteTime(monotonicTime);
  }

  advance(milliseconds: number): void {
    const elapsed = Math.max(0, finiteTime(milliseconds));
    this.wallTime += elapsed;
    this.monotonicTime += elapsed;
  }
}

function finiteTime(value: number): number {
  if (!Number.isFinite(value)) throw new TypeError('Race clock values must be finite');
  return value;
}
